import React, { Dispatch, SetStateAction } from "react"
import * as graphql from "lib/types/generated/graphql-types"
import {
  CustomReasonCode,
  CustomState,
  Maybe,
  Order,
  OrderCustomState,
  OrderHistoryLogEntry,
  StoreGroupSearchHit
} from "lib/types/generated/graphql-types"
import { ApolloError, ApolloQueryResult } from "@apollo/client"
import OrderBlock from "components/Order/OrderBlock"
import OrderOverView from "../../../../components/Order/OrderOverview/OrderTotals/OrderOverView"
import ErrorMessage from "components/Ui/Messages/ErrorMessage"
import Address from "../../../../components/Order/Address/Address"
import { AddressType } from "lib/types/order"
import { OrderLines } from "./OrderLines/OrderLines"

type Props = {
  order: graphql.Order
  orderHistory: graphql.OrderHistory
  refetch: () => Promise<ApolloQueryResult<Order>>
  refetchLoading: boolean
  getCustomCode: (code: Maybe<string> | undefined) => CustomReasonCode
  storeGroups: StoreGroupSearchHit[]
  historyProps: {
    customStates: CustomState[]
    addCustomStateToHistory: (customStateId: string) => void
    setOrderHistoryList: Dispatch<SetStateAction<OrderHistoryLogEntry[]>>
    orderHistoryList: OrderHistoryLogEntry[]
    setCustomStateList: Dispatch<SetStateAction<OrderCustomState[]>>
    customStateList: OrderCustomState[]
    getCustomState: (id: string) => CustomState | undefined
    error: ApolloError | undefined
  }
}

const OrderDetails = ({
  order,
  refetch,
  refetchLoading,
  storeGroups,
  historyProps,
  orderHistory
}: Props) => {
  if (!order) return null

  const {
    error
  } = historyProps

  return (
    <>
      {error && <ErrorMessage message={error.message} />}
      <Address
        order={order}
        address={order.billingAddress}
        addressType={AddressType.BILLING_ADDRESS}
        refetch={refetch}
        refetchLoading={refetchLoading}
        company={order?.attributes?.company}
        expandableAddress={true}
        showActionButtons={true}
      />
      <OrderOverView
        order={order}
        storeGroups={storeGroups}
        refetch={refetch}
        orderHistory={orderHistory}
      />
      <br />
      <OrderBlock>
        <OrderLines order={order} orderHistory={orderHistory} />
      </OrderBlock>
    </>
  )
}

export default OrderDetails
